import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { notifyWarn } from 'src/app/model/notification.model';
import { TechnicalInstallationService } from '../service/technical-installation.service';
import {
  announceInstallation,
  announceInstallationFailure,
  getInstallations,
  getInstallationsFailure,
  getInstallationsSuccess,
  installationUpdateSuccess,
  updateAnnouncement,
} from './technical-installation.action';

@Injectable({
  providedIn: 'root',
})
export class TechnicalInstallationEffects {
  announceInstallationEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(announceInstallation),
      switchMap(({ form, buildingId }) =>
        this.technicalInstallationService.announce(buildingId, form).pipe(
          map(installation => installationUpdateSuccess({ buildingId, installation })),
          catchError(error => of(announceInstallationFailure({ error, ...notifyWarn('building.error.unexpected', true) })))
        )
      )
    )
  );

  updateAnnouncementEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateAnnouncement),
      switchMap(({ form, installationId, buildingId }) =>
        this.technicalInstallationService.updateAnnouncement(buildingId, installationId, form).pipe(
          map(installation => installationUpdateSuccess({ buildingId, installation })),
          catchError(error => of(announceInstallationFailure({ error, ...notifyWarn('building.error.unexpected', true) })))
        )
      )
    )
  );

  getInstallationsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getInstallations, installationUpdateSuccess),
      switchMap(({ buildingId }) =>
        this.technicalInstallationService.getInstallations(buildingId).pipe(
          map(installations => getInstallationsSuccess({ installations })),
          catchError(error => of(getInstallationsFailure({ error, ...notifyWarn('building.error.unexpected', true) })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private technicalInstallationService: TechnicalInstallationService) {}
}
